import { useState } from "react";

interface CurrencyInputProps {
  label: string;
  value: string;
  onChange: (rawValue: string) => void;
  placeholder?: string;
  required?: boolean;
}

function formatDisplay(raw: string): string {
  const num = parseInt(raw.replace(/\D/g, ""), 10);
  if (isNaN(num) || num === 0) return "";
  return num.toLocaleString("tr-TR");
}

function parseRaw(display: string): string {
  const cleaned = display.replace(/\./g, "").replace(/\s/g, "");
  return cleaned;
}

export function CurrencyInput({
  label,
  value,
  onChange,
  placeholder = "0",
  required = false,
}: CurrencyInputProps) {
  const [display, setDisplay] = useState(() => formatDisplay(value));

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const raw = parseRaw(e.target.value);
    if (raw && !/^\d+$/.test(raw)) return;
    setDisplay(formatDisplay(raw));
    onChange(raw);
  }

  function handleBlur() {
    setDisplay(formatDisplay(value));
  }

  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-foreground">
        {label}
        {required && " *"}
      </label>
      <div className="relative">
        <input
          type="text"
          inputMode="numeric"
          value={display}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          required={required}
          className="h-9 w-full rounded-lg border border-border bg-secondary px-3 pr-10 text-sm text-foreground focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">
          TL
        </span>
      </div>
    </div>
  );
}
